import { Fade } from "react-awesome-reveal";
import plusIcon from "assets/images/icons/plus.png";
import minusIcon from "assets/images/icons/minus.png";
import { useState } from "react";

const Faqs = () => {
  const [activeFaq, setActiveFaq] = useState(null);

  // faq data
  const faqData = [
    {
      qs: "How does MamaZen work?",
      ans: (
        <p>
          Absolutely not. Let’s be honest, meditation is hard and rather boring.
          Instead, our Mindpower Sessions guide you through a relaxing,
          hypnotherapy based experience that will shift your subconscious mind
          and create new empowering beliefs and more positive behaviors with
          your kids. You just lay down pop your headphones in, close your eyes,
          and listen.
        </p>
      ),
    },
    {
      qs: "Is this just another meditation app?",
      ans: (
        <p>
          Absolutely not. Let’s be honest, meditation is hard and rather boring.
          Instead, our Mindpower Sessions guide you through a relaxing,
          hypnotherapy based experience that will shift your subconscious mind
          and create new empowering beliefs and more positive behaviors with
          your kids. You just lay down pop your headphones in, close your eyes,
          and listen.
        </p>
      ),
    },
    {
      qs: "What if I just have no time?",
      ans: (
        <p>
          Absolutely not. Let’s be honest, meditation is hard and rather boring.
          Instead, our Mindpower Sessions guide you through a relaxing,
          hypnotherapy based experience that will shift your subconscious mind
          and create new empowering beliefs and more positive behaviors with
          your kids. You just lay down pop your headphones in, close your eyes,
          and listen.
        </p>
      ),
    },
    {
      qs: `I’m skeptical. How do I know if this is
      going to work for me?`,
      ans: (
        <p>
          Absolutely not. Let’s be honest, meditation is hard and rather boring.
          Instead, our Mindpower Sessions guide you through a relaxing,
          hypnotherapy based experience that will shift your subconscious mind
          and create new empowering beliefs and more positive behaviors with
          your kids. You just lay down pop your headphones in, close your eyes,
          and listen.
        </p>
      ),
    },
    {
      qs: "Is there anything for dads?",
      ans: (
        <p>
          Absolutely not. Let’s be honest, meditation is hard and rather boring.
          Instead, our Mindpower Sessions guide you through a relaxing,
          hypnotherapy based experience that will shift your subconscious mind
          and create new empowering beliefs and more positive behaviors with
          your kids. You just lay down pop your headphones in, close your eyes,
          and listen.
        </p>
      ),
    },
    {
      qs: `Will this help my relationship with my
      partner?`,
      ans: (
        <p>
          Absolutely not. Let’s be honest, meditation is hard and rather boring.
          Instead, our Mindpower Sessions guide you through a relaxing,
          hypnotherapy based experience that will shift your subconscious mind
          and create new empowering beliefs and more positive behaviors with
          your kids. You just lay down pop your headphones in, close your eyes,
          and listen.
        </p>
      ),
    },
  ];

  return (
    <div className="faqs_wrapper">
      {/* <Fade triggerOnce delay={700} duration={1600}> */}
        <h3>Frequently Asked Questions</h3>
      {/* </Fade> */}
      <br />
      {faqData.map((data, i) => {
        return (
          <div
            key={i}
            className={`faq_container ${activeFaq === i ? "active_faq" : ""}`}
          >
            <div
              role="button"
              className="faq_qs d_flex align_items_center justify_content_between cursor_pointer user_select_none"
              onClick={() => setActiveFaq((prev) => (prev === i ? null : i))}
            >
              <h6>{data.qs}</h6>
              <span className="faq-arrow">
                {activeFaq === i ? (
                  <img src={minusIcon} alt="" />
                ) : (
                  <img src={plusIcon} alt="" />
                )}
              </span>
            </div>
            <div className="faqs_answer">{data.ans}</div>
          </div>
        );
      })}
    </div>
  );
};

export default Faqs;
